import { render, staticRenderFns } from "./RegisterSubscription.vue?vue&type=template&id=6cba04ef&scoped=true"
import script from "./RegisterSubscription.vue?vue&type=script&lang=js"
export * from "./RegisterSubscription.vue?vue&type=script&lang=js"
import style0 from "./RegisterSubscription.vue?vue&type=style&index=0&id=6cba04ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba04ef",
  null
  
)

export default component.exports